import axios from "axios";
import { API_URL } from "../config";

function getUserId() {
    try {
        const sessionItem = sessionStorage.getItem("persist:qmsnl");
        if (!sessionItem) return null;

        const session = JSON.parse(sessionItem);
        const auth = session.auth ? JSON.parse(session.auth) : null;
        return auth?.userInfo?.email || null;
    } catch (e) {
        return null;
    }
}

const instance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

instance.interceptors.request.use(
    (config) => {
        const userId = getUserId();
        if (userId) {
            config.headers["X-User-Id"] = userId;
        }
        return config;
    },
    (error) => Promise.reject(error),
);

export default instance;
